import {IBaseFetchOptions, IBaseParameters, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GET_QUICKSEARCH_CATEGORIES: {
		method: 'GET',
		path: 'categories'
	}
};

export interface IGetQuickSearchCategoriesOptions extends IBaseFetchOptions {
	parameters: IBaseParameters & {
		c_query: string;
		c_customerPersonalizationKey?: string;
	}
}

export interface IGetQuickSearchCategoriesResponse extends IBaseResponse {
	data: Array<Category>
}

interface Category {
	categoryId: string;
	displayName: string
	subCategories: SubCategory[];
}

interface SubCategory {
	categoryId: string
	displayName: string;
	name: string
	url: string;
	parentId: string;
	hitCount: number;
}
